import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '@/lib/posthog'
import { config } from '@/lib/config'

export const usePostHog = () => {
  const location = useLocation()

  useEffect(() => {
    // Track page view when location changes - only in production
    if (config.posthog.enabled) {
      trackPageView(location.pathname)
    } else {
      console.log('PostHog Page View (dev):', location.pathname)
    }
  }, [location.pathname])

  return null
} 